export interface Event {
  id: string;
  title: string;
  category: string;
  categoryName: string;
  time: string;
  date: string;
  status: 'live' | 'upcoming' | 'finished';
  score?: string;
  teams: { home: string; away: string };
  league: string;
}

export const featuredEvents: Event[] = [
  {
    id: 'evt-1',
    title: '曼城 vs 阿森纳',
    category: 'zuqiu',
    categoryName: '足球',
    time: '03:00',
    date: '2026-08-08',
    status: 'upcoming',
    teams: { home: '曼城', away: '阿森纳' },
    league: '英超联赛',
  },
  {
    id: 'evt-2',
    title: '皇家马德里 vs 巴塞罗那',
    category: 'zuqiu',
    categoryName: '足球',
    time: '04:00',
    date: '2026-08-09',
    status: 'upcoming',
    teams: { home: '皇家马德里', away: '巴塞罗那' },
    league: '西甲联赛',
  },
  {
    id: 'evt-3',
    title: '湖人 vs 凯尔特人',
    category: 'lanqiu',
    categoryName: '篮球',
    time: '09:30',
    date: '2026-08-07',
    status: 'live',
    score: '98 - 102',
    teams: { home: '湖人', away: '凯尔特人' },
    league: 'NBA常规赛',
  },
  {
    id: 'evt-4',
    title: '辽宁 vs 广东',
    category: 'lanqiu',
    categoryName: '篮球',
    time: '19:35',
    date: '2026-08-08',
    status: 'upcoming',
    teams: { home: '辽宁', away: '广东' },
    league: 'CBA联赛',
  },
  {
    id: 'evt-5',
    title: '德约科维奇 vs 阿尔卡拉斯',
    category: 'wangqiu',
    categoryName: '网球',
    time: '21:00',
    date: '2026-08-07',
    status: 'upcoming',
    teams: { home: '德约科维奇', away: '阿尔卡拉斯' },
    league: 'ATP大师赛决赛',
  },
  {
    id: 'evt-6',
    title: 'JDG vs BLG',
    category: 'dianjing',
    categoryName: '电竞',
    time: '17:00',
    date: '2026-08-06',
    status: 'live',
    score: '2 - 1',
    teams: { home: 'JDG', away: 'BLG' },
    league: 'LPL夏季赛',
  },
  {
    id: 'evt-7',
    title: '法拉利 vs 红牛 vs 梅赛德斯',
    category: 'zonghe',
    categoryName: '综合',
    time: '20:00',
    date: '2026-08-10',
    status: 'upcoming',
    teams: { home: '三大车队', away: '巅峰对决' },
    league: 'F1大奖赛正赛',
  },
  {
    id: 'evt-8',
    title: '拜仁慕尼黑 vs 多特蒙德',
    category: 'zuqiu',
    categoryName: '足球',
    time: '00:30',
    date: '2026-08-08',
    status: 'upcoming',
    teams: { home: '拜仁慕尼黑', away: '多特蒙德' },
    league: '德甲联赛',
  },
];